export default "__VITE_ASSET__BbqOhzgn__"